import { cn } from "../../lib/utils";
import type { AdapterType } from "../../worker/api";

export function VaultGlyph({
  adapterType,
  className,
}: {
  adapterType: AdapterType;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex h-6 w-6 items-center justify-center rounded bg-accent-bg font-mono text-[9px] font-bold uppercase tracking-tight text-accent-soft",
        className,
      )}
    >
      {adapterType === "opfs" ? "OPFS" : "S3"}
    </div>
  );
}
